import { stringifyQs } from "@dashboard/utils/urls";

export const reviewsModerationSection = "/reviews-moderation/";

export const reviewsModerationListPath = reviewsModerationSection;
export const reviewsModerationListUrl = (params?: { status?: string }) =>
  reviewsModerationListPath + (params ? "?" + stringifyQs(params) : "");

export const reviewsModerationDetailPath = (id: string) =>
  reviewsModerationSection + id;
export const reviewsModerationDetailUrl = (id: string) =>
  reviewsModerationDetailPath(encodeURIComponent(id));
